<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="mt-1" v-else>
    <v-slide-x-reverse-transition>
        <v-alert
          type="error"
          class="alert_all_page"
          v-if="alert_error === true"
          >{{ alert_message_error }}</v-alert
        >
        <v-alert
          type="success"
          class="alert_all_page"
          v-if="alert_success === true"
          >{{ alert_message_success }}</v-alert
        >
      </v-slide-x-reverse-transition>
      <v-row>
        <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">รายการใบแจ้งหนี้/ใบกำกับภาษี</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
          <div
            class="title_page ma-3"
            @click="link('/arin/pos/posinvoicestaxadd')"
          >
            <v-btn type="button" class="btn_add_data" elevation="2" large
              >สร้างใบแจ้งหนี้/ใบกำกับภาษี</v-btn
            >
          </div>
        </v-col>
      </v-row>
      <div class="mt-1">
        <v-card elevation="3" class="pa-4" style="border-radius: 15px">
          <section class="d-flex justify-space-between">
            <v-row>
              <v-col
                xs="6"
                sm="6"
                md="9"
                lg="9"
                xl="9"
                cols="6"
                class="content-header-title"
              >
                <!-- <p class="text-red" style="color: red;font-size: 14px;">คำเตือน : การพิมพ์ใบกำกับภาษีสามารถกด "พิมพ์" ได้เพียงแค่ครั้งเดียว</p> -->
              </v-col>
              <v-col xs="6" sm="6" md="3" lg="3" xl="3" cols="6">
                <div class="mt-1">
                  <v-text-field
                    color="#D6BFAF"
                    class="input-radius"
                    append-icon="mdi-magnify"
                    hide-details="auto"
                    required
                    v-model="search"
                    placeholder="ค้นหา..."
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </section>

          <section class="pa-3">
            <v-data-table
              :headers="headers"
              :items="data_list"
              :search="search"
              :footer-props="footer_Props"
              mobile-breakpoint="0"
            >
              <template v-slot:item="dataDetail">
                <tr>
                  <td>
                    <div class="font-16">
                      {{ dataDetail.item.invoice_code }}
                    </div>
                  </td>
                  <td>
                    <div class="font-16">
                      {{ dataDetail.item.tax_invoice_code }}
                    </div>
                  </td>
                  <td>
                    <div class="font-16">{{ dataDetail.item.doc_date }}</div>
                  </td>
                  <td>
                    <div @click="cancel_order()" class="font-16">
                      {{ dataDetail.item.buyer_name }}
                    </div>
                  </td>
                  <td>
                    <!-- <div v-if="dataDetail.item.credit_charge_status == 1 && dataDetail.item.pay_type.find(o => o === 3)" class="font-16">{{formatPrice(parseFloat(dataDetail.item.net_total) + (parseFloat(dataDetail.item.net_total) * parseFloat(dataDetail.item.credit_charge) / 100))}}</div> -->
                    <div class="font-16">
                      {{ formatPrice(dataDetail.item.net_total) }}
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span>
                        <v-btn
                          elevation="2"
                          class="my-3 mx-2 font-16"
                          outlined
                          color="#8EBBDC"
                          title="ดูรายละเอียด"
                          style="border-radius: 10px"
                          @click="
                            link(
                              '/arin/pos/posinvoicestaxdetail/' +
                                dataDetail.item.id
                            )
                          "
                        >
                          <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                        </v-btn>
                      </span>
                      <!-- {{ dataDetail.item }} -->
                      <span>
                        <!-- {{ dataDetail.item.status_print }} -->
                        <v-btn
                          elevation="2"
                          class="my-3 font-16"
                          outlined
                          color="#88B358"
                          title="พิมพ์"
                          @click="handlePrint(dataDetail.item.invoice_id , dataDetail.item.id)"
                          style="border-radius: 10px"
                        >
                          <v-icon>mdi-printer</v-icon> พิมพ์
                        </v-btn>
                      </span>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </section>
        </v-card>
      </div>

      <!-- Modal การแจ้งเตือนเสร็จสิ้น -->
      <v-dialog
        v-model="show_check_print_success"
        persistent
        max-width="500px"
      >
        <v-card class="input-radius pa-5">
          <v-card-title>
            <v-row>
              <v-col class="text-right py-0">
                <v-btn
                  icon
                  class="ma-1"
                  @click="show_check_print_success = false"
                >
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text class="pb-10">
            <v-row>
              <v-col cols="12" class="title_page_center justify-center">
                <div class="">
                  <v-img width="178" class="w-100" :src="img_check"></v-img>
                </div>
              </v-col>
              <v-col cols="12 text-center">
                <h1 class="">พิมพ์ใบกำกับภาษีเรียบร้อย จะไม่สามารถพิมพ์ได้อีก</h1>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

    </div>
  </div>
</template>
  
<script>

import { HTTP_ARIN } from "@/axios_arin";
import {
  formatPrice,
} from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_invoices_tax",
  data() {
    return {
      loading_page: false,
      dialog_cancel_order: false,
      search: "",
      footer_Props: {
        "items-per-page-text": "รายการต่อหน้า",
      },
      show_check_print_success: false,
      alert_error: false,
      alert_message_error: null,
      alert_success: false,
      alert_message_success: null,
      headers: [
        {
          text: "เลขที่ใบเสร็จ",
          value: "receipt_number",
          fixed: true,
          width: "120px",
        },
        {
          text: "เลขที่ใบแจ้งหนี้/ใบกำกับภาษี",
          value: "receipt_tax",
          fixed: true,
          width: "200px",
        },
        {
          text: "วันที่เอกสาร",
          value: "receipt_date",
          fixed: true,
          width: "120px",
        },
        {
          text: "ชื่อลูกค้า",
          value: "receipt_name",
          fixed: true,
          width: "210px",
        },
        {
          text: "ยอดเงินสุทธิ",
          value: "receipt_price",
          fixed: true,
          width: "130px",
        },
        {
          text: "จัดการ",
          value: "",
          fixed: true,
          width: "120px",
        },
      ],

      data_list: [],
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "การขาย",
          disabled: false,
        },
        {
          text: "ใบแจ้งหนี้/ใบกำกับภาษี",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    link(link, bank = null) {
      if (bank != null) {
        window.open(link, "_blank");
      } else {
        window.location.href = link;
      }
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    printInvoice(invoiceId) {
      const printUrl = `/arin/pos/pospapertaxinvoices?id=${invoiceId}`;
      const newWindow = window.open(printUrl, "_blank");

      // ตรวจสอบว่า window ถูกบล็อกหรือไม่ (ป้องกันกรณี popup blocker)
      if (newWindow) {
        newWindow.onload = function () {
          newWindow.print();
        };
      } else {
        alert("Please allow pop-ups to print the document.");
      }
    },
    async handlePrint(invoiceId,id) {
    
      try {
        const config = {
            headers: {
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
            },
        };
       
        HTTP_ARIN.post(`/pos/update/invoiceprint`, {id: id}, config).then((res) => {
            console.log(res);
            if (res.data.successful === true) {
                window.open(`/arin/pos/pospapertaxinvoices?id=${invoiceId}&status_print=${id}`, "_blank");
                this.alert_success = true;
                this.alert_message_success = "ใบเสร็จถูกพิมพ์เรียบร้อยแล้ว";
                this.show_check_print_success = true;
                setTimeout(() => (this.show_check_print_success = false), 3000);
                setTimeout(() => (this.alert_success = false), 5000);
                window.location.reload();
            }else {
                alert(res.message);
            }
        });
        
      } catch (error) {
        console.error("Error printing invoice:", error);
        alert("เกิดข้อผิดพลาดในการพิมพ์");
      }
    },
    async getInvoiceList() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get("/tax/invoice", config).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.data;
        }
      });
    },
  },
  mounted() {
    this.getInvoiceList();
  },
};
</script>
  
<style scoped>
.btn_add_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  /* width: 200px; */
}
</style>
  